import { auth } from './firebase';

export const getFirebaseAuthToken = async (): Promise<string | null> => {
  const user = auth.currentUser;
  if (!user) {
    return null;
  }

  return user.getIdToken();
};
